/**
 * SideMenu用Script
 */
import $ from "jquery";

/* 実行Function 判定 */
export const runScriptBySidemenu = (currentRouteName: string) => {
    // ルート名からアクション名を除外
    const routeArray = currentRouteName.split(".");
    const routeName = routeArray[0];
    const actionName = routeArray[1];

    switch (routeName) {
        // ―― MasterMaintenance ――
        // ユーザマスタメンテナンス
        case "user":
        // 車輌マスタメンテナンス
        case "car":
        // 車種マスタメンテナンス
        case "car_model":
        // 部署マスタメンテナンス
        case "department":
        // 特約金額マスタメンテナンス
        case "special_contract_amount":
        // 保険会社マスタメンテナンス
        case "insurance_company":
        // 使用目的マスタメンテナンス
        case "usage_objective":
            addClassByMasterMaintenanceSideMenu(actionName);
            break;
        // ―― ./MasterMaintenance ――
        // ―― Profile ――
        // 個人情報変更
        case "profile":
        // マイスケジュール
        case "my_schedule":
            addClassByProfileSideMenu(currentRouteName);
            break;
        // ―― ./Profile ――
        // ―― Schedule ――
        case "schedule":
        case "schedule_csv":
        case "schedule_unset":
        case "schedule_past_history":
            addClassByScheduleSideMenu(currentRouteName);
            break;
        // ―― ./Schedule ――
        // ―― CarStatus ――
        case "car_status":
        case "car_inspection_status":
            addClassByCarStatusSideMenu(currentRouteName);
            break;
        // ―― ./CarStatus ――
    }
};

/* MasterMaintenance */
const addClassByMasterMaintenanceSideMenu = (actionName: string) => {
    switch (actionName) {
        case "index":
        case "create":
        case "edit":
            // editの場合、#side_index にClassを付与する
            const id =
                actionName == "edit" ? "#side_index" : "#side_" + actionName;
            // Class付与
            $(id).addClass("now");
            break;
    }
};

/* Profile */
const addClassByProfileSideMenu = (actionName: string) => {
    let id = "";
    switch (actionName) {
        case "profile.edit":
            // editの場合、#side_index にClassを付与する
            id = "#profile";
            // Class付与
            $(id).addClass("now");
            break;
        case "my_schedule.index":
            id = "#mySchedule";
            $(id).addClass("now");
            break;
    }
};

/* Schedule */
const addClassByScheduleSideMenu = (actionName: string) => {
    switch (actionName) {
        case "schedule.index":
        case "schedule.edit":
            $("#side_schedule_index").addClass("now");
            break;
        case "schedule_csv.index":
            $("#side_schedule_csv_index").addClass("now");
            break;
        case "schedule.create":
            $("#side_schedule_create").addClass("now");
            break;
        case "schedule_unset.index":
            $("#side_schedule_unset_index").addClass("now");
            break;
        case "schedule_past_history.index":
            $("#side_schedule_past_history_index").addClass("now");
            break;
    }
};

/* CarStatus */
const addClassByCarStatusSideMenu = (actionName: string) => {
    switch (actionName) {
        case "car_status.index":
        case "car_status.show":
            $("#side_car_status_index").addClass("now");
            break;
        case "car_inspection_status.index":
        case "car_inspection_status.show":
            $("#side_car_inspection_status_index").addClass("now");
            break;
    }
};

/* グローバル関数を定義 */
(window as any).addClassBySideMenu = runScriptBySidemenu;
